/**
 * Returns the URL only if it is a safe https:// link or a relative path.
 * Blocks javascript:, data:, vbscript: and any other dangerous protocols.
 */
export function safeUrl(url) {
  if (!url) return null
  if (url.startsWith('/')) return url
  try {
    const { protocol } = new URL(url)
    return protocol === 'https:' ? url : null
  } catch {
    return null
  }
}
